module.exports = __webpack_public_path__ + "/images/cover-onboading-guest-screenshot-vertical@2x.5c0dcf5.png";